interface CatchLogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES = {
  sm: { symbol: 'h-6', wordmark: 'h-5', gap: 'gap-1' },
  md: { symbol: 'h-8', wordmark: 'h-7', gap: 'gap-1.5' },
  lg: { symbol: 'h-10', wordmark: 'h-9', gap: 'gap-2' },
}

export function CatchLogo({ size = 'md', className = '' }: CatchLogoProps): JSX.Element {
  const s = SIZES[size]
  return (
    <div className={`flex items-center ${s.gap} ${className}`}>
      <img src="/images/logo/symbol.svg" alt="" className={`${s.symbol} w-auto`} />
      <img src="/images/logo/wordmark.svg" alt="Catch" className={`${s.wordmark} w-auto`} />
    </div>
  )
}
